module.exports = __webpack_public_path__ + "static/media/16-11.d8fcdbd2.mp3";